// import React, { useState } from 'react';
//import './navbar.css';
// import { Link } from "react-router-dom"
 
 

 
const Home_page = () => {
//    const [somma, calcola_somma] = useState('');
    return (
        <div>
              <meta name="google-site-verification" content="41koyjuQrY2sSqTdFc8U-50ZtSwyX6Wkhl8iUhiIaEg" />
              <h1>Tutor PCTO IPSIA PACINOTTI PONTEDERA ciao1212</h1>

			
        </div>
    )
}
export default Home_page;